import { render } from "./AppLogoWhite.vue?vue&type=template&id=0c96aaa6"
const script = {}

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__